<template>
  <div>
    <el-dialog
      title="设备列表"
      :visible="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
    >
      <el-row style="margin-bottom: 20px;">
        <el-col :span="5">
          <el-select v-model="area" placeholder="请选择">
            <el-option
              v-for="item in option.area"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="margin-left:6px;">
          <el-select v-model="engineRoom" placeholder="请选择">
            <el-option
              v-for="item in option.engineRoom"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="8">
          <el-input placeholder="输入关键字搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="5"
          v-for="(item, index) in deviceArray"
          :key="item.id"
          style="margin-bottom:40px;width: 25%;"
        >
          <div @click="handleCheckedChange(item, index, $event)" class="divChecked">
            <el-card
              :body-style="{ padding: '0px'}"
              :class="{active:index == active}"
              shadow="hover"
              :offset="1"
              style="width: 200px;height: 100%;cursor:pointer;"
            >
              <device :item="item" />
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row style="text-align:center;">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="cancelCallback">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Device from './Device.vue'
export default {
  name: "DeviceList",
  components: { Device },
  props: {
    visible: {
      type: Boolean
    }
  },
  data: vm => ({
    active: null,
    area: "全部",
    engineRoom: "全部",
    search: "",
    option: {
      area: [{ label: "全部", value: "全部" }],
      engineRoom: [{ label: "全部", value: "全部" }]
    },
    optionBackup: new Map(),
    deviceArray: [], //设备列表
    deviceArrayBackup: [],
    current: {}
  }),
  created(){
      this.findAll()
  },
  methods: {
    /**
     * 选中设备时,显示设备详细信息
     * @param val
     */
    handleCheckedChange(row, index, e) {
      this.active = index;
      this.current = row
    },
    findAll() {
      this.$axios.get(this.baseUrl3 + "management3/device/findAll")
      .then(({ data: { msg, data, code } }) => {
        if(code == 20000){
          this.deviceArray = data
          this.deviceArrayBackup = data
        }else{
          this.$message({ showClose: true, message: msg, type: "error" });
          console.log(msg);
        }
      });
    },
    save(){
        this.current.type = 'device'
        this.$emit('chooseCallback', this.current)
    },
    cancelCallback(){
      this.$emit('cancelCallback', 'showDevice')
    }
  },
  watch: {
    /**
     * 监听 area
     */
    area(val) {
      this.deviceArray = this.deviceArrayBackup;
      this.option.engineRoom = [{ label: "全部", value: "全部" }];
      this.optionBackup.forEach((value, key) => {
        if (key == val) {
          for (let i in value) {
            let engineRoom = {
              label: value[i],
              value: value[i]
            };
            this.option.engineRoom.push(engineRoom);
          }
        }
      });
      this.engineRoom = "全部";
      if (val != "全部") {
        this.deviceArray = this.deviceArray.filter(data => {
          return data.area == val;
        });
      }
    },
    /**
     * 监听 engineRoom
     */
    engineRoom(val) {
      if (this.area == "全部") {
        this.deviceArray = this.deviceArrayBackup;
      } else {
        this.deviceArray = this.deviceArrayBackup.filter(data => {
          return data.area == this.area;
        });
      }
      if (val != "全部") {
        this.deviceArray = this.deviceArray.filter(data => {
          return data.area == this.area && data.affiliatedComputerRoom == val;
        });
      }
    },
    /**
     * 监听 search 设备
     */
    search(val) {
      if (val) {
        this.deviceArray = this.deviceArrayBackup.filter(data => {
          return Object.keys(data).some(key => {
            return (
              String(data[key])
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1
              // String(data[key])
              //   .toLowerCase() == val.toLowerCase()
            );
          });
        });
      } else {
        this.deviceArray = this.deviceArrayBackup;
      }
    }
  }
};
</script>
<style scoped>
.divChecked .active {
    background-color: #409eff;
    border-color: #409eff;
  }

  .divCheckedNetwork .active {
    background-color: #409eff;
    border-color: #409eff;
  }
</style>
